export default __webpack_public_path__ + "static/media/kheng-videos1.7f1de51f.jpg";